import Permissao from './Permissao';

/**
 * Modelo dos dados de um administrador
 */
class Administrador {

    /**
     * Cria uma nova instância de administrador
     * @param {Number} id Identificação do administrador
     * @param {String} nome Nome do administrador
     * @param {String} email Email do administrador
     * @param {String} telefone Telefone do administrador
     * @param {String} senha Senha do administrador
     * @param {Array<Permissao>} permissoes Lista de permissões do administrador
     * @param {Date} dataCadastro Data de inclusão do administrador
     * @param {Date} dataAlteracao Data da última alteração do administrador
     */
    constructor(id, nome, email, telefone, senha, permissoes, dataCadastro, dataAlteracao) {
        /** @member {Number} id Identificação do administrador */
        this.id = id ?? null;
        /** @member {String} nome Nome do administrador */
        this.nome = nome ?? null;
        /** @member {String} email Email do administrador */
        this.email = email ?? null;
        /** @member {String} telefone Telefone do administrador */
        this.telefone = telefone ?? null;
        /** @member {String} senha Senha do administrador */
        this.senha = senha ?? null;
        /** @member {Array<Permissao>} permissoes Lista de permissões do administrador */
        this.permissoes = permissoes ?? [ ];
        /** @member {Date} dataCadastro Data de inclusão do administrador */
        this.dataCadastro = dataCadastro ?? null;
        /** @member {Date} dataAlteracao Data da última alteração do administrador */
        this.dataAlteracao = dataAlteracao ?? null;
    }

    /**
     * Copia os dados de um objeto
     * @param {Administrador} administrador Objeto a ser clonado
     * @returns {Administrador} Retorna um novo objeto com os mesmos dados
     */
    static clone(administrador) {
        //Copia a lista de permissões
        let permissoes = null;
        if (administrador.permissoes)
            permissoes = administrador.permissoes.map(permissao => Permissao.clone(permissao));

        return new Administrador(administrador.id, administrador.nome, administrador.email, administrador.telefone, administrador.senha, permissoes, administrador.dataCadastro, administrador.dataAlteracao);
    }
}

export default Administrador;